import {
  WizardDropdown,
  WizardDropdownOption,
} from 'common/components/WizardControls/WizardDropdown';
import { Season } from 'common/models/season';
import { selectBaseStyling } from 'features/pick-schedule-views/components/WizardComponents/wizardStyles';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { createSeasonOptions } from 'utils/formValues/dropdownOptions';

export type SelectedSeason = {
  season: WizardDropdownOption<Season> | null;
};

export const SeasonSelector: FC<{
  /** The `useForm` control of the form wrapping the dropdown. */
  control: Control<SelectedSeason>;
  seasons: Season[];
  isLoading: boolean;
  isDisabled?: boolean;
}> = ({ control, seasons, isLoading, isDisabled = false }) => {
  return (
    <WizardDropdown<Season>
      name='season'
      formControl={control}
      options={createSeasonOptions(seasons)}
      isLoading={isLoading}
      styles={selectBaseStyling}
      maxWidth='100px'
      isDisabled={isDisabled}
    />
  );
};
